(function() {
  const header = document.querySelector('.header');
  
  function updateHeader() {
    if (window.scrollY < 80) {
      header?.classList.add('header--transparent');
    } else {
      header?.classList.remove('header--transparent');
    }
  }

  if (header) {
    updateHeader();
    window.addEventListener('scroll', updateHeader);
  }
})();
